import Redux from 'redux';
import {
  CREATE_POLL,
  DELETE_POLL,
  FETCH_POLL_STATE_FB,
  SET_BACKGROUND,
  SET_SCORE,
  SYNC_POLL_STATE_FB,
  RESULTS_VIEW_IS_BUBBLES,
} from './actions';
import theme from '../theme';

/**
 * initial state
 */

interface IPersistedState {
  polls?: {
    [pollId: string]: {
      owner: string;
      scores: {
        [scoreId: string]: string; // scoreId is a timestamp,
      };
    };
  };
}

export interface IAppState extends IPersistedState {
  background: string,
  resultsViewIsBubbles: boolean;
  currentUserScore: number;
}

const initialState: IAppState = {
  background: theme.background,
  resultsViewIsBubbles: false,
  currentUserScore: 0,
};

export const rootReducer = (state = initialState, action: Redux.AnyAction) => {
  switch (action.type) {
    case SET_BACKGROUND:
      return { ...state, background: action.background };
    case SET_SCORE:
      return {
        ...state,

        // FIXME: Work out how to do the user bit better here!
        currentUserScore: action.currentUserScore,
      };
    case CREATE_POLL:
      return { ...state, polls: action.polls };
    case DELETE_POLL:
      return { ...state, polls: action.polls };
    case FETCH_POLL_STATE_FB:
      return { ...state, polls: action.polls };
    case SYNC_POLL_STATE_FB:
      return {
        ...state,
        polls: {
          ...state.polls,
          [action.id]: action.data,
        },
      };
    case RESULTS_VIEW_IS_BUBBLES:
      return { ...state, resultsViewIsBubbles: action.switch };
    default:
      return state;
  }
};
